import Store from 'lightningjs-redux';

import { getCurrentLayout } from '../../logic/layout/layout.selectors';
import { getRouteSkeleton, isTopLevelRoute } from '../../logic/routing/routing.selectors';

const mapControllers = instance => [
  {
    selector: getCurrentLayout,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.layout = value;
    },
  },
  {
    selector: isTopLevelRoute,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.hasSideNav = value;
    },
  },
  {
    selector: getRouteSkeleton,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.skeleton = value;
    },
  },
];

export default Store.control(mapControllers);
